/* ODCAF Express — print artwork upload + preview (cut line / safe area / fold lines). Used by business cards, postcards, flyers & brochures. */
(function () {
  var PDFJS = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/';
  var SIZES = {
    standard: { name: 'Standard card', tw: 3.5, th: 2, bw: 3.65, bh: 2.12 },
    square: { name: 'Square card', tw: 2.5, th: 2.5, bw: 2.62, bh: 2.62 }
  };
  var DEFAULT_SAFE = 0.125;
  var pdfLoading = null;

  function loadPdfJs() {
    if (window.pdfjsLib) return Promise.resolve(window.pdfjsLib);
    if (pdfLoading) return pdfLoading;
    pdfLoading = new Promise(function (res, rej) {
      var s = document.createElement('script');
      s.src = PDFJS + 'pdf.min.js';
      s.onload = function () {
        window.pdfjsLib.GlobalWorkerOptions.workerSrc = PDFJS + 'pdf.worker.min.js';
        res(window.pdfjsLib);
      };
      s.onerror = rej;
      document.head.appendChild(s);
    });
    return pdfLoading;
  }

  /* "Paste a link to your file" (Canva, Google Drive, Dropbox, WeTransfer) — saved on the order as "Artwork link" */
  function linkBox(formId, intro) {
    var d = document.createElement('div');
    d.className = 'odx-link';
    d.setAttribute('data-odx-link', '');
    var id = 'OdxLink-' + formId;
    d.innerHTML = '<label for="' + id + '">' + intro + ' <small>(Canva, Google Drive, Dropbox or WeTransfer)</small></label>' +
      '<input type="text" id="' + id + '" name="properties[Artwork link]" form="' + formId + '" placeholder="Paste your file link (https://)" inputmode="url" autocomplete="off" spellcheck="false">' +
      '<p class="odx-link__hint">Make sure the link is shared so anyone with it can view. Links also work for files over 20 MB.</p>';
    return d;
  }
  function linkValue(box) {
    var inp = box && box.querySelector('input');
    var v = inp ? inp.value.trim() : '';
    if (v && !/^https?:\/\//i.test(v) && /\./.test(v)) { v = 'https://' + v; inp.value = v; }
    return v;
  }
  function linkOk(v) { return /^https?:\/\/[^\s.]+\.[^\s]{2,}/i.test(v); }

  var linkCss = '' +
    '.odx-link[data-odx-link]{display:block;white-space:normal;margin-top:14px;padding:12px 14px;border:1.5px solid #e8e8ef;border-radius:12px;background:#fff}' +
    '.odx-link label{display:block;font-weight:700;font-size:13.5px;margin:0 0 6px}' +
    '.odx-link label small{font-weight:500;color:#5b5d6b}' +
    '.odx-link input{width:100%;box-sizing:border-box;border:1.5px solid #d6d7e0;border-radius:10px;padding:10px 12px;font:inherit;font-size:14px;background:#f7f7fa}' +
    '.odx-link input:focus{outline:none;border-color:#d4147f;background:#fff}' +
    '.odx-link.is-bad input{border-color:#a3122f}' +
    '.odx-link__hint{margin:6px 0 0 !important;font-size:12px;color:#5b5d6b;line-height:1.45}' +
    '.odx-link__or{display:flex;align-items:center;gap:10px;margin:14px 0 0 !important;font-size:12px;font-weight:700;color:#5b5d6b;text-transform:uppercase;letter-spacing:.06em}' +
    '.odx-link__or::before,.odx-link__or::after{content:"";flex:1;height:1px;background:#e8e8ef}';
  function addLinkCss() {
    if (document.getElementById('odx-link-css')) return;
    var st = document.createElement('style'); st.id = 'odx-link-css'; st.textContent = linkCss; document.head.appendChild(st);
  }

  function fmtIn(n) { return (Math.round(n * 100) / 100).toString(); }

  function rotate(sz) {
    return { name: sz.name, tw: sz.th, th: sz.tw, bw: sz.bh, bh: sz.bw, rotated: true, round: sz.round, safe: sz.safe };
  }
  /* "4''x6''", "2''x6'' (Bookmark)", "5.5 x 8.5 in".
     bleed: added on every side (file = size + bleed). trim: cut from every side (file = size, card = size - trim). */
  function parseSize(title, bleed, noun, trim) {
    title = String(title || '');
    var round = /circle|round/i.test(title);
    var m = /(\d+(?:\.\d+)?)\s*(?:''|"|″|in(?:ch(?:es)?)?)?\s*[x×]\s*(\d+(?:\.\d+)?)/i.exec(title);
    var a, b;
    if (m) { a = parseFloat(m[1]); b = parseFloat(m[2]); }
    else {
      /* one dimension, e.g. "3'' (circle)" or "3 in round" */
      var one = /(\d+(?:\.\d+)?)\s*(?:''|"|″|in(?:ch(?:es)?)?)/i.exec(title);
      if (!one) return null;
      a = b = parseFloat(one[1]);
    }
    if (/\d\s*(?:''|"|″)?\s*ft\b|feet|foot/i.test(title) && !/\(\s*\d/.test(title)) { a *= 12; b *= 12; }
    var p = /\(([^)]+)\)/.exec(title);
    var name = 'Your ' + noun;
    if (p && !/\d\s*[x×]\s*\d/i.test(p[1]) && !/circle|round/i.test(p[1])) name = p[1];
    else if (p && /\d\s*[x×]\s*\d/i.test(p[1])) name = title.split('(')[0].trim() || name;
    else if (round) name = 'Round ' + noun;
    var sz = trim ? { name: name, tw: a - 2 * trim, th: b - 2 * trim, bw: a, bh: b } : { name: name, tw: a, th: b, bw: a + 2 * bleed, bh: b + 2 * bleed };
    sz.round = round;
    return sz;
  }
  function setVars(el, size) {
    var st = el.style;
    var SAFE = size.safe != null ? size.safe : DEFAULT_SAFE;
    st.setProperty('--bw', size.bw);
    st.setProperty('--bh', size.bh);
    st.setProperty('--tw', size.tw);
    st.setProperty('--th', size.th);
    st.setProperty('--bx', ((size.bw - size.tw) / 2 / size.bw * 100) + '%');
    st.setProperty('--by', ((size.bh - size.th) / 2 / size.bh * 100) + '%');
    st.setProperty('--sx', (((size.bw - size.tw) / 2 + SAFE) / size.bw * 100) + '%');
    st.setProperty('--sy', (((size.bh - size.th) / 2 + SAFE) / size.bh * 100) + '%');
    st.setProperty('--cw', (size.bw / size.tw * 100) + '%');
    st.setProperty('--ch', (size.bh / size.th * 100) + '%');
    st.setProperty('--cx', (-(size.bw - size.tw) / 2 / size.tw * 100) + '%');
    st.setProperty('--cy', (-(size.bh - size.th) / 2 / size.th * 100) + '%');
  }

  function init(root) {
    var formId = root.getAttribute('data-form');
    var sid = root.getAttribute('data-section');
    var form = document.getElementById(formId);
    if (!form) return;
    var variants = {};
    try { variants = JSON.parse(document.getElementById('OdxBCVariants-' + sid).textContent); } catch (e) {}
    var bleed = parseFloat(root.getAttribute('data-bleed')) || 0;
    var trim = parseFloat(root.getAttribute('data-trim')) || 0;
    var noun = root.getAttribute('data-noun') || 'card';
    var fixedSize = root.getAttribute('data-size');
    var safeIn = root.hasAttribute('data-safe') ? parseFloat(root.getAttribute('data-safe')) : null;
    var plain = root.hasAttribute('data-plain');
    if (plain) root.classList.add('is-plain');
    var folds = parseInt(root.getAttribute('data-folds'), 10) || 0;
    var foldByVariant = root.hasAttribute('data-fold-by-variant');
    var size = SIZES.standard;
    var slots = {};
    var pdfBackPage = null; // rendered page 2 of a front PDF, used when no back file

    Array.prototype.forEach.call(root.querySelectorAll('[data-slot]'), function (el) {
      var key = el.getAttribute('data-slot');
      var s = slots[key] = {
        key: key,
        el: el,
        input: el.querySelector('input[type=file]'),
        card: el.querySelector('.odx-bcu__card'),
        img: el.querySelector('.odx-bcu__img'),
        empty: el.querySelector('.odx-bcu__empty'),
        name: el.querySelector('[data-name]'),
        msgs: el.querySelector('[data-msgs]'),
        info: null
      };
      s.input.addEventListener('change', function () { handleFile(s); });
      el.querySelector('[data-pick]').addEventListener('click', function () { s.input.click(); });
      s.empty.addEventListener('click', function () { s.input.click(); });
      el.querySelector('[data-remove]').addEventListener('click', function () {
        s.input.value = '';
        handleFile(s);
      });
      ['dragenter', 'dragover'].forEach(function (t) {
        s.card.addEventListener(t, function (e) { e.preventDefault(); s.card.classList.add('is-drag'); });
      });
      ['dragleave', 'drop'].forEach(function (t) {
        s.card.addEventListener(t, function (e) { e.preventDefault(); s.card.classList.remove('is-drag'); });
      });
      s.card.addEventListener('drop', function (e) {
        if (!e.dataTransfer || !e.dataTransfer.files.length) return;
        try {
          var dt = new DataTransfer();
          dt.items.add(e.dataTransfer.files[0]);
          s.input.files = dt.files;
        } catch (err) { return; }
        handleFile(s);
      });
    });

    var slotKeys = Object.keys(slots);
    var primary = slots[slotKeys[0]], secondary = slots[slotKeys[1]];

    /* guides / cut view toggles */
    var guides = root.querySelector('[data-guides]');
    var cut = root.querySelector('[data-cut]');
    function applyView() {
      root.classList.toggle('no-guides', guides && !guides.checked);
      root.classList.toggle('is-cut', cut && cut.checked);
    }
    if (guides) guides.addEventListener('change', applyView);
    if (cut) cut.addEventListener('change', applyView);

    /* fold lines (e.g. trifold brochures): evenly split the finished area, across the long side */
    function drawFolds(s, sz) {
      Array.prototype.forEach.call(s.card.querySelectorAll('.odx-bcu__fold'), function (n) { n.remove(); });
      if (!folds) return;
      var wide = sz.bw >= sz.bh;
      for (var i = 1; i <= folds; i++) {
        var f = document.createElement('span');
        f.className = 'odx-bcu__fold ' + (wide ? 'is-v' : 'is-h');
        if (wide) f.style.left = (((sz.bw - sz.tw) / 2 + sz.tw * i / (folds + 1)) / sz.bw * 100) + '%';
        else f.style.top = (((sz.bh - sz.th) / 2 + sz.th * i / (folds + 1)) / sz.bh * 100) + '%';
        s.card.appendChild(f);
      }
    }

    /* brochures: fold count comes from the selected variant; sides are Outside/Inside when folded, Front/Back when flat */
    var relabeled = false;
    function relabel() {
      relabeled = true;
      var names = folds ? ['Outside', 'Inside'] : ['Front', 'Back'];
      var notes = folds ? ['(required)', folds === 2 ? '(3 inside panels)' : '(2 inside panels)'] : ['(required)', '(optional — leave empty for a blank back)'];
      slotKeys.forEach(function (k, i) {
        var sl = slots[k]; if (!names[i]) return;
        sl.key = names[i].toLowerCase();
        sl.input.name = 'properties[' + names[i] + ' artwork]';
        var lb = sl.el.querySelector('[data-slot-label]'); if (lb) lb.textContent = names[i];
        var nt = sl.el.querySelector('[data-slot-note]'); if (nt) nt.textContent = notes[i];
        var dr = sl.el.querySelector('[data-slot-drop]'); if (dr) dr.textContent = 'Drop your ' + sl.key + ' design here';
      });
      var it = root.querySelector('[data-intro]');
      var txt = root.getAttribute(folds ? 'data-intro-fold' : 'data-intro-flat');
      if (it && txt) { it.textContent = txt; introDefault = txt; if (design && design.checked) applyDesign(); }
    }

    /* card size from the selected variant */
    function applySize() {
      var idInput = form.querySelector('input[name="id"]');
      var v = idInput && variants[idInput.value];
      fixedSize = root.getAttribute('data-size');
      if (fixedSize) size = parseSize(fixedSize, bleed, noun, trim) || size;
      if (foldByVariant && v) {
        var ft = String(v.t || '').toLowerCase();
        var nf = /tri/.test(ft) ? 2 : /bi/.test(ft) ? 1 : 0;
        if (nf !== folds || !relabeled) { folds = nf; relabel(); }
        size.name = nf === 2 ? 'Trifold brochure, flat' : nf === 1 ? 'Bifold brochure, flat' : 'Flat sheet (no fold)';
      }
      else if (root.hasAttribute('data-custom-size')) { /* custom size typed by the customer: keep data-size */ }
      else if (bleed || trim) size = (v && parseSize(v.s || v.t, bleed, noun, trim)) || size;
      else size = v && /square/i.test(v.t) ? SIZES.square : SIZES.standard;
      if (plain) size = { name: fixedSize || 'Your design', tw: 1, th: 1, bw: 1, bh: 1 };
      if (root.hasAttribute('data-round')) size.round = true;
      if (safeIn != null) size.safe = safeIn;
      root.classList.toggle('is-round', !!size.round);
      Array.prototype.forEach.call(root.querySelectorAll('.odx-bcu__line rect'), function (r) {
        r.setAttribute('rx', size.round ? '50%' : '0'); r.setAttribute('ry', size.round ? '50%' : '0');
      });
      setVars(root, size);
      Object.keys(slots).forEach(function (k) { if (!slots[k].info) drawFolds(slots[k], size); });
      Array.prototype.forEach.call(root.querySelectorAll('[data-size-label]'), function (n) {
        if (plain) { n.textContent = size.name; return; }
        var dims = size.round ? fmtIn(size.tw) + ' in circle' : fmtIn(size.tw) + ' × ' + fmtIn(size.th) + ' in';
        var fileDims = fmtIn(size.bw) + ' × ' + fmtIn(size.bh) + ' in';
        n.textContent = size.name + ': ' + dims + (size.bw !== size.tw || size.bh !== size.th ? ' · file with bleed ' + fileDims : '');
      });
      Object.keys(slots).forEach(function (k) { if (slots[k].info) check(slots[k]); });
    }
    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('variant-radios, variant-selects')) setTimeout(applySize, 80);
    });
    root.__odxApply = function () { applySize(); };
    /* design service changes the wording */
    var design = document.querySelector('[data-odx-design]');
    var intro = root.querySelector('[data-intro]');
    var introDefault = intro ? intro.innerHTML : '';
    applySize();
    setTimeout(applySize, 300);
    function applyDesign() {
      var on = design && design.checked;
      root.classList.toggle('is-design', !!on);
      if (intro) intro.innerHTML = on ? 'Optional: upload your logo or any image you want on it. We’ll use it in your design.' : introDefault;
      if (on) setError('');
      Object.keys(slots).forEach(function (k) { if (slots[k].info) check(slots[k]); });
    }
    if (design) design.addEventListener('change', applyDesign);

    function setMsgs(s, list) {
      s.msgs.innerHTML = '';
      list.forEach(function (m) {
        var li = document.createElement('li');
        li.className = 'is-' + m[0];
        li.textContent = m[1];
        s.msgs.appendChild(li);
      });
    }

    function showImage(s, src) {
      s.img.src = src;
      s.el.classList.add('has-file');
    }

    function clearSlot(s) {
      s.info = null;
      s.img.removeAttribute('src');
      s.el.classList.remove('has-file', 'no-preview', 'from-pdf', 'is-vertical');
      s.el.removeAttribute('style');
      drawFolds(s, size);
      s.name.textContent = '';
      setMsgs(s, []);
    }

    function handleFile(s) {
      var f = s.input.files && s.input.files[0];
      clearSlot(s);
      if (s === primary) { pdfBackPage = null; syncBackFromPdf(); }
      if (!f) return;
      setError('');
      s.name.textContent = f.name;
      var type = (f.type || '').toLowerCase();
      var ext = (f.name.split('.').pop() || '').toLowerCase();
      if (f.size > 20 * 1024 * 1024) {
        s.el.classList.add('has-file', 'no-preview');
        setMsgs(s, [['bad', 'This file is over 20 MB, so it can’t be uploaded here. Save a smaller version (PNG, JPG or PDF), or paste a link to it below.']]);
        s.info = { kind: 'big' };
        return;
      }
      if (/^image\/(png|jpe?g|webp|gif)$/.test(type) || /^(png|jpe?g|webp|gif)$/.test(ext)) {
        var url = URL.createObjectURL(f);
        var probe = new Image();
        probe.onload = function () {
          s.info = { kind: 'image', w: probe.naturalWidth, h: probe.naturalHeight };
          showImage(s, url);
          check(s);
        };
        probe.onerror = function () { noPreview(s); };
        probe.src = url;
      } else if (type === 'application/pdf' || ext === 'pdf') {
        s.el.classList.add('has-file', 'is-loading');
        loadPdfJs().then(function (lib) {
          return f.arrayBuffer().then(function (buf) { return lib.getDocument({ data: buf }).promise; });
        }).then(function (pdf) {
          return renderPage(pdf, 1).then(function (r1) {
            s.info = { kind: 'pdf', w: r1.wIn, h: r1.hIn, pages: pdf.numPages };
            showImage(s, r1.src);
            s.el.classList.remove('is-loading');
            check(s);
            if (s === primary && pdf.numPages > 1) {
              return renderPage(pdf, 2).then(function (r2) {
                pdfBackPage = r2;
                syncBackFromPdf();
              });
            }
          });
        }).catch(function () {
          s.el.classList.remove('is-loading');
          noPreview(s, 'We couldn’t show a preview of this PDF, but it will be attached to your order and we’ll check it for you.');
        });
      } else {
        noPreview(s);
      }
    }

    function renderPage(pdf, n) {
      return pdf.getPage(n).then(function (page) {
        var vp1 = page.getViewport({ scale: 1 });
        var scale = Math.min(4, 1400 / vp1.width);
        var vp = page.getViewport({ scale: scale });
        var c = document.createElement('canvas');
        c.width = Math.round(vp.width); c.height = Math.round(vp.height);
        var ctx = c.getContext('2d');
        ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, c.width, c.height);
        return page.render({ canvasContext: ctx, viewport: vp }).promise.then(function () {
          return { src: c.toDataURL('image/png'), wIn: vp1.width / 72, hIn: vp1.height / 72 };
        });
      });
    }

    function syncBackFromPdf() {
      var b = secondary;
      if (!b || (b.input.files && b.input.files.length)) return;
      if (pdfBackPage) {
        b.info = { kind: 'pdf', w: pdfBackPage.wIn, h: pdfBackPage.hIn, fromFront: true };
        showImage(b, pdfBackPage.src);
        b.el.classList.add('from-pdf');
        b.name.textContent = 'Page 2 of your ' + primary.key + ' PDF';
        check(b);
      } else if (b.el.classList.contains('from-pdf')) {
        clearSlot(b);
      }
    }

    function noPreview(s, text) {
      s.el.classList.add('has-file', 'no-preview');
      s.info = { kind: 'other' };
      setMsgs(s, [['info', text || 'Preview isn’t available for this file type, but your file will be attached to the order. For a preview, upload a PNG, JPG or PDF.']]);
    }

    function check(s) {
      var i = s.info, m = [];
      if (!i) return;
      var designing = design && design.checked;
      var sz = size;
      s.el.removeAttribute('style');
      s.el.classList.remove('is-vertical');
      var fileTall = i.h > i.w * 1.05, fileWide = i.w > i.h * 1.05;
      var sizeTall = size.bh > size.bw * 1.05, sizeWide = size.bw > size.bh * 1.05;
      if ((i.kind === 'image' || i.kind === 'pdf') && ((fileTall && sizeWide) || (fileWide && sizeTall))) {
        sz = rotate(size);
        setVars(s.el, sz);
        s.el.classList.add('is-vertical');
      }
      drawFolds(s, sz);
      if (plain) {
        setVars(s.el, { tw: i.w || 1, th: i.h || 1, bw: i.w || 1, bh: i.h || 1, safe: 0 });
        if (designing) { setMsgs(s, [['info', 'Got it — we’ll use this file in your design.']]); return; }
        var pm = [];
        if (i.kind === 'image') {
          var big = Math.max(i.w, i.h);
          pm.push(big >= 1500 ? ['ok', 'Image size ' + i.w + ' × ' + i.h + ' px — good for print ✓'] : ['warn', 'Image size ' + i.w + ' × ' + i.h + ' px — it may look blurry. A larger image (1500 px or more) works best.']);
        }
        if (pm.some(function (x) { return x[0] === 'warn'; })) pm.push(['info', 'You can still place your order. We check every file and will contact you before printing if anything needs fixing.']);
        setMsgs(s, pm);
        return;
      }
      if (designing) {
        setMsgs(s, [['info', 'Got it — we’ll use this file in your design.']]);
        return;
      }
      if (sz.rotated) m.push(['info', (fileTall ? 'Vertical' : 'Horizontal') + ' layout: ' + fmtIn(sz.tw) + ' × ' + fmtIn(sz.th) + ' in (file with bleed ' + fmtIn(sz.bw) + ' × ' + fmtIn(sz.bh) + ' in).']);
      var bleedR = sz.bw / sz.bh, trimR = sz.tw / sz.th;
      if (i.kind === 'image' || i.kind === 'pdf') {
        var r = i.w / i.h;
        var offBleed = Math.abs(r - bleedR) / bleedR;
        var offTrim = Math.abs(r - trimR) / trimR;
        if (offBleed <= 0.015 || (bleedR === trimR && offBleed <= 0.03)) {
          m.push(['ok', 'Shape matches the selected size with bleed ✓']);
        } else if (offTrim < offBleed && offTrim <= 0.015) {
          m.push(['warn', 'Your file looks like it has no bleed. Backgrounds and edge colors should extend to ' + fmtIn(sz.bw) + ' × ' + fmtIn(sz.bh) + ' in, or a thin white edge may show after cutting.']);
        } else {
          m.push(['warn', 'Your file’s shape doesn’t match the selected size. We print as submitted, so white edges may show (see preview). Resize it to ' + fmtIn(sz.bw) + ' × ' + fmtIn(sz.bh) + ' in.']);
        }
      }
      if (i.kind === 'image') {
        var dpi = Math.round(Math.min(i.w / sz.bw, i.h / sz.bh));
        var goal = parseInt(root.getAttribute('data-dpi'), 10) || 300;
        var px = Math.round(sz.bw * goal) + ' × ' + Math.round(sz.bh * goal) + ' px';
        if (dpi >= goal * 0.97) m.push(['ok', 'Resolution about ' + dpi + ' DPI — great for print ✓']);
        else if (dpi >= goal / 2) m.push(['warn', 'Resolution about ' + dpi + ' DPI — may look slightly soft. ' + goal + ' DPI is recommended (' + px + ').']);
        else m.push(['bad', 'Resolution about ' + dpi + ' DPI — too low, it will print blurry. Please upload a larger file (' + px + ').']);
      }
      if (i.kind === 'pdf') {
        var match = Math.abs(i.w - sz.bw) < 0.06 && Math.abs(i.h - sz.bh) < 0.06;
        m.push([match ? 'ok' : 'info', 'PDF page size: ' + fmtIn(i.w) + ' × ' + fmtIn(i.h) + ' in' + (match ? ' ✓' : '')]);
        if (s === primary && secondary && i.pages > 1) m.push(['info', 'Your PDF has ' + i.pages + ' pages — page 2 is used as the ' + secondary.key + ' unless you upload a separate ' + secondary.key + ' file.']);
      }
      m.push(['info', 'Keep all text and logos inside the green safe line.']);
      if (m.some(function (x) { return x[0] === 'warn' || x[0] === 'bad'; })) {
        m.push(['info', 'You can still place your order. We check every file and will contact you before printing if anything needs fixing.']);
      }
      setMsgs(s, m);
    }

    /* link to the file instead of (or as well as) uploading */
    addLinkCss();
    var link = linkBox(formId, 'Or paste a link to your file');
    var errEl = root.querySelector('[data-error]');
    root.insertBefore(link, errEl);
    link.querySelector('input').addEventListener('input', function () { link.classList.remove('is-bad'); setError(''); });

    /* submit: front file (or a link) required unless we design it; drop empty file inputs */
    var err = errEl;
    function setError(t) { if (err) { err.textContent = t; err.hidden = !t; } }
    document.addEventListener('submit', function (e) {
      if (e.target !== form) return;
      var designing = design && design.checked;
      var front = primary, hasFront = front && front.input.files && front.input.files.length;
      var lv = linkValue(link), linkInput = link.querySelector('input');
      if (lv && !linkOk(lv)) {
        e.preventDefault(); e.stopImmediatePropagation();
        link.classList.add('is-bad');
        setError('Please paste the full link to your file, starting with https://');
        linkInput.focus();
        return;
      }
      if (!designing && !hasFront && !lv) {
        e.preventDefault(); e.stopImmediatePropagation();
        setError('Please upload your ' + primary.key + ' design, paste a link to it, or check the design option above.');
        root.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      if (!lv) { linkInput.disabled = true; setTimeout(function () { linkInput.disabled = false; }, 1500); }
      if (front && front.info && front.info.kind === 'big' && !lv) {
        e.preventDefault(); e.stopImmediatePropagation();
        setError('Your ' + primary.key + ' file is over 20 MB. Upload a smaller file or paste a link to it.');
        return;
      }
      Object.keys(slots).forEach(function (k) {
        var inp = slots[k].input;
        if (!inp.files || !inp.files.length || (slots[k].info && slots[k].info.kind === 'big')) {
          inp.disabled = true;
          setTimeout(function () { inp.disabled = false; }, 1500);
        }
      });
    }, true);
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-odx-bcu]'), function (r) {
      if (r.__odx) return; r.__odx = true; init(r);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
